export const loginModel = {
	username: "",
	password: "",
};
